/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Typography, Snackbar,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { userActions } from '../../../redux/actions/userActions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  formContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(8),
    alignItems: 'center',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: '80%',
    marginLeft: '10%',
  },
  backButton: {
    margin: theme.spacing(1, 0, 1),
    width: '80%',
    marginLeft: '0%',
  },
  title: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#333',
    marginBottom: theme.spacing(2),
  },
  message: {
    fontSize: '0.9rem',
    fontWeight: 400,
    marginTop: '15px',
    textAlign: 'center',
  },
  successMessage: {
    color: 'green',
  },
  errorMessage: {
    color: 'red',
  },
}));

const ForgotPasswordForm = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [email, setEmail] = useState('');
  const [errorMail, setErrorMail] = useState(false);
  const [message, setMessage] = useState('');
  const [openAzureWarning, setOpenAzureWarning] = useState(false);
  const [openFail, setOpenFail] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const requestNewPassword = useSelector((state) => state.user.requestNewPassword);
  const newPassword = useSelector((state) => state.user.newPassword);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenAzureWarning(false);
    setOpenFail(false);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setErrorMail(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const azureRegex = /^.+onmicrosoft\.com$/i;
    const isAzure = azureRegex.test(email);
    if (isAzure) {
      setOpenAzureWarning(true);
      setErrorMail(true);
      return;
    }

    try {
      await dispatch(userActions.forgotPassword(email));
      setMessage(t(
        'auth.forgotPassword.successGeneric',
        "Un e-mail de réinitialisation a été envoyé si l'adresse existe.",
      ));
    } catch (error) {
      setMessage(t(
        'auth.forgotPassword.errorGeneric',
        'Erreur lors de la demande. Veuillez réessayer.',
      ));
      setOpenFail(true);
      setErrorMail(true);
    }
  };

  useEffect(() => {
    if (newPassword || requestNewPassword) {
      // optional
    }
  }, [newPassword, requestNewPassword]);

  const isErrorMessage = message.includes(t('common.errorPrefix', 'Erreur'));

  return (
    <div className={classes.formContainer}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openAzureWarning}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="warning">
          {t(
            'auth.forgotPassword.azureAccountWarning',
            'Impossible de changer le mot de passe d’un compte Microsoft.',
          )}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openFail}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="warning">
          {t(
            'auth.forgotPassword.emailSendFailed',
            'Impossible d’envoyer un email à cette adresse.',
          )}
        </Alert>
      </Snackbar>

      <Typography variant="h6" className={classes.title}>
        {t(
          'auth.forgotPassword.title',
          'Entrez votre adresse mail pour réinitialiser votre mot de passe :',
        )}
      </Typography>

      <form className={classes.form} noValidate onSubmit={handleSubmit}>
        <TextField
          label={t('auth.forgotPassword.emailLabel', 'Adresse e-mail')}
          variant="outlined"
          margin="normal"
          required
          fullWidth
          error={errorMail}
          value={email}
          onChange={handleEmailChange}
          type="email"
          autoFocus
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.submit}
          fullWidth
          disabled={requestNewPassword || newPassword}
        >
          {requestNewPassword
            ? t('auth.forgotPassword.sending', 'Envoi en cours')
            : (newPassword
              ? t('auth.forgotPassword.checkMailbox', 'Merci de vérifier votre boîte mail')
              : t('auth.forgotPassword.submit', 'Réinitialiser le mot de passe'))}
        </Button>
      </form>

      {message && (
        <Typography
          variant="body2"
          className={`${classes.message} ${isErrorMessage ? classes.errorMessage : classes.successMessage}`}
        >
          {message}
        </Typography>
      )}

      <Button
        variant="outlined"
        color="secondary"
        onClick={() => history.push('/login')}
        className={classes.backButton}
        fullWidth
      >
        {t('auth.forgotPassword.backToLogin', 'Retour à la connexion')}
      </Button>
    </div>
  );
};

export default ForgotPasswordForm;
